module.exports = __webpack_public_path__ + "static/media/Boiler.d07382bf.png";